import React, { useState } from 'react';
import { IconEye, IconEyeOff, IconMail, IconLock, IconArrowLeft } from '@tabler/icons-react';
interface LoginPageProps {
  onLogin: () => void;
  onSwitchToRegister: () => void;
  onBack?: () => void;
}
export function LoginPage({
  onLogin,
  onSwitchToRegister,
  onBack
}: LoginPageProps) {
  const [email, setEmail] = useState('fabio.rossi@email.com');
  const [password, setPassword] = useState('password123');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Login:', {
      email,
      password,
      rememberMe
    });
    onLogin();
  };
  return <div className="flex flex-col min-h-screen bg-yeppy-bg" data-id="element-863">
      {/* Header - Standard navbar */}
      {onBack && <div className="px-4 pt-4 pb-3" data-id="element-864">
          <div className="flex items-center gap-3 mb-3" data-id="element-865">
            <button onClick={onBack} className="flex items-center justify-center w-10 h-10 bg-white border border-yeppy-text border-opacity-15 rounded-full transition-colors flex-shrink-0" aria-label="Indietro" data-id="element-866">
              <IconArrowLeft className="w-5 h-5 text-yeppy-text" stroke={1.5} data-id="element-867" />
            </button>
          </div>
        </div>}

      {/* Content */}
      <div className={`flex-1 overflow-y-auto px-4 py-6 ${!onBack ? 'pt-6' : ''}`} data-id="element-868">
        <div className="w-full max-w-md mx-auto" data-id="element-869">
          {/* Logo */}

          {/* Login Card */}
          <div className="bg-white border border-yeppy-text border-opacity-10 rounded-2xl p-6 mb-4" data-id="element-870">
            <h2 className="font-rubik text-lg text-yeppy-text mb-2 text-center font-[500]" data-id="element-871">
              Bentornato!
            </h2>
            <p className="font-poppins text-sm text-yeppy-text text-opacity-60 mb-6 text-center" data-id="element-872">
              Accedi al tuo account per continuare
            </p>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-873">
              {/* Email */}
              <div data-id="element-874">
                <label htmlFor="email" className="block font-poppins text-sm font-medium text-yeppy-text mb-2" data-id="element-875">
                  Email
                </label>
                <div className="relative" data-id="element-876">
                  <IconMail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-877" />
                  <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="mario.rossi@email.com" className="w-full pl-12 pr-4 py-3 rounded-xl font-poppins text-sm text-yeppy-text bg-white border border-yeppy-text border-opacity-15 focus:outline-none focus:border-yeppy-blue focus:border-opacity-50 transition-colors placeholder-yeppy-text placeholder-opacity-40" required data-id="element-878" />
                </div>
              </div>

              {/* Password */}
              <div data-id="element-879">
                <label htmlFor="password" className="block font-poppins text-sm font-medium text-yeppy-text mb-2" data-id="element-880">
                  Password
                </label>
                <div className="relative" data-id="element-881">
                  <IconLock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-882" />
                  <input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" className="w-full pl-12 pr-12 py-3 rounded-xl font-poppins text-sm text-yeppy-text bg-white border border-yeppy-text border-opacity-15 focus:outline-none focus:border-yeppy-blue focus:border-opacity-50 transition-colors placeholder-yeppy-text placeholder-opacity-40" required data-id="element-883" />
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-4 top-1/2 -translate-y-1/2" data-id="element-884">
                    {showPassword ? <IconEyeOff className="w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-885" /> : <IconEye className="w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-886" />}
                  </button>
                </div>
              </div>

              {/* Remember Me & Forgot Password */}
              <div className="flex items-center justify-between" data-id="element-887">
                <label className="flex items-center gap-2 cursor-pointer" data-id="element-888">
                  <input type="checkbox" checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} className="w-4 h-4 rounded border-2 border-yeppy-text border-opacity-20 text-yeppy-blue focus:ring-2 focus:ring-yeppy-blue focus:ring-opacity-30" data-id="element-889" />
                  <span className="font-poppins text-sm text-yeppy-text text-opacity-70" data-id="element-890">
                    Ricordami
                  </span>
                </label>
                <button type="button" className="font-poppins text-sm text-yeppy-text transition-opacity" data-id="element-891">
                  Password dimenticata?
                </button>
              </div>

              {/* Login Button */}
              <button type="submit" className="w-full py-3 rounded-xl font-poppins text-sm font-semibold transition-colors" style={{
              backgroundColor: '#1D2A36',
              color: '#FFFFFB'
            }} data-id="element-892">
                Accedi
              </button>
            </form>
          </div>

          {/* Register Link */}
          <div className="text-center" data-id="element-893">
            <p className="font-poppins text-sm text-yeppy-text text-opacity-60" data-id="element-894">
              Non hai un account?{' '}
              <button onClick={onSwitchToRegister} className="font-semibold text-yeppy-text transition-opacity" data-id="element-895">
                Registrati
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>;
}